import React from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExportExcel = ({ filename, value }) => {
  const exportToExcel = () => {
    if (!value || Object.keys(value).length === 0) {
      return;
    }

    const sheets = Object.keys(value);
    if (sheets.length === 0) {
      return;
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Process each sheet
    sheets.forEach((sheetName) => {
      const sheetData = value[sheetName];

      // Transform data to flat objects
      const data = sheetData.data.map((row) => {
        const obj = {};
        sheetData.columns.forEach((col, index) => {
          obj[col.title] = row[index].value;
        });
        return obj;
      });

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data, {
        header: sheetData.columns.map((col) => col.title),
      });

      // Set column widths
      ws['!cols'] = sheetData.columns.map((col) => ({
        wch: Math.ceil(col.width.wpx / 7),
      }));

      // Set number formats
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        sheetData.columns.forEach((col, C) => {
          const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && sheetData.data[R - 1][C].style?.numFmt) {
            cell.z = sheetData.data[R - 1][C].style.numFmt;
          }
        });
      }

      // Add the worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    // Generate buffer
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true,
    });

    // Create blob and save
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, `${filename}.xlsx`);
  };

  if (!value || Object.keys(value).length === 0) {
    return <span></span>;
  }

  const sheets = Object.keys(value);
  if (sheets.length === 0 || !value[sheets[0]].data?.length) {
    return <span></span>;
  }

  return (
    <Button
      variant="contained"
      color="success"
      size="small"
      onClick={exportToExcel}
    >
      Export
    </Button>
  );
};

ExportExcel.propTypes = {
  filename: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
};

export default ExportExcel;
